export function initializePendo(user: string, env: string) {
  if (!user || !env) return
  pendo.initialize({
    apiKey: 'f34e377f-e71c-40d8-8f16-1f8852cb29ec',
    visitor: { id: user },
    account: { id: env },
  })
}
